import {
  APPLICATION_NAMES_CAN_CHANGE_CLASSES_AND_LEVELS,
  MACKENZIE_HYBRIDA_APPLICATION_ID,
  MACKENZIE_PROPRIA_APPLICATION_ID,
} from './constants'

const canChangeSchoolClassesAndLevels = ({
  byIntegration,
  schoolBrands,
  userExternalReference,
  isUserByIntegration,
}) => {
  const isSchoolBrandAbleToChangeClassesAndLevels = schoolBrands?.some(({ name }) =>
    name.includes(APPLICATION_NAMES_CAN_CHANGE_CLASSES_AND_LEVELS),
  )

  const isUserExternalReferenceAbleToChangeClassesAndLevels = userExternalReference?.some(
    ({ applicationId }) =>
      applicationId === MACKENZIE_HYBRIDA_APPLICATION_ID ||
      applicationId === MACKENZIE_PROPRIA_APPLICATION_ID,
  )

  if (
    byIntegration &&
    (isSchoolBrandAbleToChangeClassesAndLevels ||
      isUserExternalReferenceAbleToChangeClassesAndLevels)
  ) {
    return true
  }

  if (!isUserByIntegration) {
    return true
  }

  return !byIntegration
}

export default canChangeSchoolClassesAndLevels
